const mainStores = ['white-fox-boutique-aus.myshopify.com', 'white-fox-boutique-usa.myshopify.com'];
const themeIsPublished = (window.Shopify.theme.role !== 'unpublished');
const devMode = false;
const inProduction = (mainStores.indexOf(Shopify.shop) !== -1) && themeIsPublished && !devMode;

const {
  regionCode,
  currentRegion,
  shopCurrency,
} = window.theme;
const currentCurrency = Shopify.currency.active;

const spotifyKey = {
  au: '92ab41742df14b68852c5e2a32aee68e',
  us: '26e758608e0d4072be6de36e83019e59',
  uk: '5cf6ba6986b44df88a3c6b16fa29bb13',
}[currentRegion];

const spotifyAddToCart = (w, d) => {
  // Installation script generated by Ad Analytics
  var id = 'spdt-capture',
    n = 'script';
  if (!d.getElementById(id)) {
    w.spdt =
      w.spdt ||
      function() {
        (w.spdt.q = w.spdt.q || []).push(arguments);
      };
    var e = d.createElement(n);
    e.id = id;
    e.async = 1;
    e.src = 'https://pixel.byspotify.com/ping.min.js';
    var s = d.getElementsByTagName(n)[0];
    s.parentNode.insertBefore(e, s);
  }
  w.spdt('conf', {
    key: spotifyKey,
  });
  w.spdt('addtocart');
};

const tikTokItemToPacket = (item) => {
  return {
    value: item.price / 100, // number. Value of the order or items sold. Example: 100.
    currency: currentCurrency, // string. The 4217 currency code. Example: "USD".
    contents: [
      {
        content_id: `shopify_${ regionCode.toUpperCase() }_${ item.id }`, // string. ID of the product. Example: "1077218".
        content_type: 'product', // string. Either product or product_group.
        content_name: item.title, // string. The name of the page or product. Example: "shirt".
        variant: item.variant_title, // Add variant information if available.
      }
    ],
  };
};

// UK Tiktok Analytics 
const tikTokAddToCart = (item) => {
  try {
    const ttqPacket = {
      ...tikTokItemToPacket(item),
      ...{
        value: item.price / 100, // number. Value of the order or items sold. Example: 100.
        currency: currentCurrency, // string. The 4217 currency code. Example: "USD".
      },
    };
    ttq.track('AddToCart', ttqPacket);
  } catch (error) {
    console.warn('Error with analytics: tikTokAddToCart');
    console.warn(error);
  }
};

// Facebook Analytics
const facebookItemToPacket = (item) => {
  return {
    content_name: item.title,
    content_category: item.product_type,
    content_ids: [`shopify_${ regionCode.toUpperCase() }_${ item.id }`],
    value: item.price / 100,
    variant: item.variant_title,
  };
};

const facebookWishListItemToPacket = (item) => {
  return {
    contentName: item.getAttribute('data-ptitle'),
    content_ids: item.getAttribute('data-product'),
  };
};

const facebookAddToWishList = (item) => {
  try {
    const fbqPacket = {
      ...facebookWishListItemToPacket(item)
    };

    fbq('track', 'AddToWishlist', fbqPacket);
  } catch (err) {
    console.warn('Error with analytics: facebookAddToWishList');
    console.warn(err);
  }
};

const facebookAdd = (item, adjustment) => {
  try {
    const fbqPacket = {
      ...facebookItemToPacket(item),
      ...{
        currency: currentCurrency,
        content_type: 'product',
      }
    };

    fbq('track', 'AddToCart', fbqPacket);
  } catch (err) {
    console.warn('Error with analytics: facebookAdd');
    console.warn(err);
  }
};

// Datalayer
const datalayerItemToPacket = (item) => {
  return {
    name: item.title,
    sku: item.sku,
    id: item.product_id,
    price: item.price / 100,
    brand: item.vendor.replace("'", ''),
    variant: item.variant_title.replace("'", ''),
    variant_id: item.variant_id,
    // quantity: 1,
    category: item.product_type,
  };
};

const dataLayerAdd = (item, adjustment) => {
  try {
    const packet = {
      event: 'addToCart',
      ecommerce: {
        currencyCode: currentCurrency,
        add: {
          products: [{
            ...datalayerItemToPacket(item),
            ...{
              quantity: Math.abs(adjustment),
            }
          }]
        }
      }
    };

    window.dataLayer.push(packet);
  } catch (err) {
    console.warn('Error with analytics: dataLayerAdd');
    console.warn(err);
  }
};

const dataLayerRemove = (item, adjustment) => {
  try {
    const packet = {
      event: 'removeFromCart',
      ecommerce: {
        currencyCode: currentCurrency,
        remove: {
          products: [{
            ...datalayerItemToPacket(item),
            ...{
              quantity: Math.abs(adjustment),
            }
          }]
        },
      },
    };

    window.dataLayer.push(packet);
  } catch (err) {
    console.warn('Error with analytics: dataLayerRemove');
    console.warn(err);
  }
};

const datalayerItemsToPacket = items => items.map(item => {
  return {
    ...datalayerItemToPacket(item),
    ...{
      quantity: item.quantity,
      total_discount: item.total_discount,
      discounted_price: item.discounted_price,
      discounts: item.discounts,
    },
  };
});

const dataLayerCartView = (cart = window.theme.cart) => {
  try {
    const packet = {
      event: 'viewCart',
      ecommerce: {
        cart: {
          currency: cart.currency,
          item_count: cart.item_count,
          items: datalayerItemsToPacket(cart.items),
          total_price: cart.total_price / 100,
        },
      },
    };

    window.dataLayer.push(packet);
  } catch (err) {
    console.warn('Error with analytics: dataLayerCartView');
    console.warn(err);
  }
};

// All together now
const add = (item, adjustment) => {
  try {
    if (!inProduction) {
      console.log('Not in production: Analytics not firing', 'add', item.id, adjustment);
      return;
    }
    facebookAdd(item, adjustment);
    dataLayerAdd(item, adjustment);
    spotifyAddToCart(window, document);

    if (currentRegion === 'uk') {
      tikTokAddToCart(item);
    }

    
  } catch (err) {
    console.warn('Error with analytics: add');
    console.warn(err);
  }
};

const addToWishList = (item) => {
  try {
    if (!inProduction) {
      console.log('Not in production: Analytics not firing', 'addToWishList', item);
      return;
    }

    facebookAddToWishList(item);
  } catch (err) {
    console.warn('Error with analytics: addToWishList');
    console.warn(err);
  }
};

const remove = (item, adjustment) => {
  try {
    if (!inProduction) {
      console.log('Not in production: Analytics not firing', 'remove', item.id, adjustment);
      return;
    }
    dataLayerRemove(item, adjustment);

  } catch (err) {
    console.warn('Error with analytics: remove');
    console.warn(err);
  }
};

const change = (item, adjustment) => {
  try {
    if (!inProduction) {
      console.log('Not in production: Analytics not firing', 'change', item.id, adjustment);
      return;
    }
    return adjustment > 0 ? add(item, adjustment) : remove(item, adjustment);

  } catch (err) {
    console.warn('Error with analytics: change');
    console.warn(err);
  }
};

const cartView = () => {
  try {
    if (!inProduction) {
      console.log('Not in production: Analytics not firing', 'cart view');
      return;
    }
    dataLayerCartView();

  } catch (err) {
    console.warn('Error with analytics: add');
    console.warn(err);
  }
};

window.analytics = {
  add,
  addToWishList,
  remove,
  change,
  cartView,
};